export default __webpack_public_path__ + "assets/images/MaskCombosThreshold-2e8752013b23d4593bcc1a506edd870d.png";